export default __webpack_public_path__ + "static/media/eight.5d9ab644.glb";